import { memo } from 'react';
import { PreloadAttachmentsResponse } from '@/modules/api/types';
import { sanitizeImageUrl } from '@/utils';
import { Backdrop, Container, RemoveIcon, Thumbnail, ThumbnailWrapper } from './UploadPreview.styles';

export interface UploadPreviewProps {
  attachments: PreloadAttachmentsResponse;
  onRemove: (index: number) => void;
}

export const UploadPreview = memo<UploadPreviewProps>(({ attachments, onRemove }) => {
  const images = attachments
    .map((attachment, index) => ({ ...attachment, index }))
    .filter(({ type }) => type === 'image');

  if (images.length === 0) {
    return null;
  }

  return (
    <Container>
      {images.map(({ url, index }) => (
        <ThumbnailWrapper key={index}>
          <Thumbnail src={sanitizeImageUrl(url)} alt={`attachment ${index + 1}`} />
          <Backdrop
            aria-label="remove attachment"
            onClick={() => {
              onRemove(index);
            }}
          >
            <RemoveIcon />
          </Backdrop>
        </ThumbnailWrapper>
      ))}
    </Container>
  );
});

UploadPreview.displayName = 'UploadPreview';
